module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flowchart-object jsplumb-draggable jsplumb-droppable",
    style: ({
      left: _vm.obj.view.left + "px",
      top: _vm.obj.view.top + "px",
      width: _vm.obj.view.w + "px",
      height: _vm.obj.view.h + "px"
    }),
    attrs: {
      "id": _vm.obj.view.id
    }
  }, [_c('div', {
    staticClass: "redirect_shell"
  }, [_c('div', {
    staticClass: "title control"
  }, [_c('div', {
    staticClass: "redirectTitle"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.konstruktor.canvas.add.redirectToOperator')))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        return _vm.deleteNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.redirect),
      expression: "obj.redirect"
    }],
    staticClass: "input sipNumber",
    attrs: {
      "placeholder": _vm.$t('scenarios.konstruktor.canvas.answer.sipSubUrl'),
      "title": _vm.$t('scenarios.konstruktor.canvas.answer.sipDubUrl')
    },
    domProps: {
      "value": (_vm.obj.redirect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "redirect", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4109630b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/Redirect.vue
// module id = 479
// module chunks = 42